<template>
    <div class="row">
        <div class="main-content col-12 col-md-7 col-lg-5 mx-auto">
            <div class="account-box">
                 <router-link to="/" class="logo">
                        <img :src="baseInfo.LogoPicPath" :title="baseInfo.ShopName" :alt="baseInfo.ShopName" />
                    </router-link>
                <div class="account-box-title">ثبت‌نام</div>
                <!--<div class="message-light">
                    اگر قبلا با ایمیل ثبت‌نام کرده‌اید، نیاز به
                    ثبت‌نام مجدد با شماره
                    همراه ندارید
                </div>-->
                <div class="account-box-content">
                    <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
                        <img style="position:absolute;top:40%;left:43%;z-index:100" src="/assets/img/loader/loader.svg" />
                    </div>
                    <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                        <li v-for="error in errors.all()">{{ error }}</li>
                    </ul>
                    <form @submit.prevent="validateForm" class="form-account">
                        <div class="form-account-title">شماره موبایل</div>
                        <div class="form-account-row">
                            <label class="input-label"><i class="now-ui-icons tech_mobile"></i></label>
                            <input name="username" class="input-field" type="text" v-model="register.UserName" v-validate="{ required: true, regex:/^[\u06F0-\u06F90-9]{11}$/i }" data-vv-as="شماره موبایل"
                                   placeholder=" شماره موبایل خود را وارد نمایید">
                        </div>
                         
                        <div class="form-account-agree">
                            <label class="checkbox-form checkbox-primary">
                                <input type="checkbox" v-model="checked">
                                <span class="checkbox-check"></span>
                            </label>
                            <label for="agree">
                                <a href="#" class="btn-link-border">حریم خصوصی</a> و <a href="#"
                                                                                        class="btn-link-border">شرایط و قوانین</a> استفاده از سرویس های سایت
                                 را مطالعه نموده و با کلیه موارد آن موافقم.
                            </label>
                        </div>
                        <div class="form-account-row form-account-submit">
                            <div class="parent-btn">
                                <button :class="{'disadledbtn' :!checked ,'dk-btn dk-btn-info':true}" :disabled="!checked">
                                    ثبت نام
                                    <i class="now-ui-icons users_circle-08"></i>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="account-box-footer">
                    <span>قبلا ثبت‌نام کرده‌اید؟</span>
                    <router-link to="/loginWithMobile" tag="a" class="btn-link-border">
                        وارد شوید
                    </router-link>
                    <div>
                        <router-link class="btn-redirect-page" to="/">بازگشت به صفحه اصلی</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../../module/httpUtility";
    export default {
        data() {
            return {
                register: {},
                checked: true,
                isShowSppiner:false
            }
        },
        methods: {
            validateForm() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowSppiner = true;
                        httpPromise(this, '/v1/Identity/ConfirmationCodeWithMobiles/AddForRegister', 'post', JSON.stringify(this.register),
                            response => {
                                this.isShowSppiner = false;
                                this.$emit('redirectToConfirm', response.data.Value);
                            },
                            response => {
                                toastr.error(response.data.Message);
                                this.isShowSppiner = false;
                            });
                    }
                });
            },
        },
        beforeMount: function () {
            createPageTitle('ثبت نام ');
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        } ,

    }
</script>

<style scoped>
    .btn-redirect-page {
        background-color: #fff8f8;
        border-bottom: 1px dashed #1ca2bd;
        margin-top: 10px;
        display: inline-block;
        border-radius: 5px;
        color: #1ca2bd;
        transition: all .3s;
        padding: 6px;
        font-size: 12px;
    }

        .btn-redirect-page:hover {
            transition: all .3s;
            color: #1ca2bd;
        }
</style>